import * as React from 'react';
import { SVGProps } from 'react';

const IconNodeStepSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 6h14v2.126a4.007 4.007 0 0 1 2 0V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2.126a4.007 4.007 0 0 1 2 0V6zm0 9.874a4.01 4.01 0 0 1-2 0V18a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2.126a4.01 4.01 0 0 1-2 0V18H5v-2.126zM22 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM4 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
  </svg>
);
export default IconNodeStepSizeM;
